import React from 'react';

interface TableProps {
  headers: any[];
  data: any[];
  fancy?: boolean;
}

export default class Table extends React.Component<TableProps, any> {
  static defaultProps = {
    fancy: false,
  }

  render() {
    const classes = this.props.fancy ? 'fancy-table' : 'table';

    return (
      <table className={classes}>
        <thead>
          {this.renderHeader()}
        </thead>
        <tbody>
          {this.renderRows()}
        </tbody>
      </table>
    );
  }

  renderHeader = () => {
    return (
      <tr>
        {this.renderHeaders()}
      </tr>
    );
  }

  renderHeaders = () => {
    return this.props.headers.map((header, i) => {
      return (
        <th key={i}>{header}</th>
      );
    });
  }

  renderRows = () => {
    return this.props.data.map((item, i) => {
      return this.renderRow(item, i);
    });
  }

  renderRow = (item: any, i: number) => {
    return (
      <tr key={i}>
        {this.renderTds(item)}
      </tr>
    );
  }

  renderTds = (item: any) => {
    return this.props.headers.map((header, i) => {
      return <td key={i}>{item[header]}</td>;
    });
  }
}
